import { Helper } from "../core/util/helper";
import React from "react";

export class TempDescription extends React.Component<any, any> {
    
    render() {
        let style =Helper.hasValue(this.props.field.cusStyle)?this.props.field.cusStyle: {backgroundColor:"#eaeaea" ,lineHeight:"1.4"};
        return (<>
            <label style={style}>
                {this.props.field.text}
            </label>
            </>);
    }
}